export const leisureQuestions = {
  conversation1: {
    id: 1,
    title: "Play Rescheduling",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure1.mp3",
        script: `<mark>M</mark>: Hi, this is William from Theater Plaza. I'm calling about your ticket reservation for "Shakespeare's Classics" on June 15.
<span class="translation">(안녕하세요, Theater Plaza의 William입니다. 6월 15일 "셰익스피어 클래식" 공연 예매 건으로 연락드렸습니다.)</span>

<mark>W</mark>: Yes, I have two tickets for that night. Is there an issue?
<span class="translation">(네, 그날 밤 티켓 두 장을 가지고 있어요. 무슨 문제가 있나요?)</span>

<mark>M</mark>: Unfortunately, that performance has been <mark>rescheduled</mark> to June 17 due to a scheduling conflict.
<span class="translation">(유감스럽게도, 일정 충돌로 인해 그 공연이 6월 17일로 변경되었습니다.)</span>

<mark>W</mark>: Oh, I see. Are my <mark>tickets still valid</mark> for the new date?
<span class="translation">(아, 그렇군요. 새로운 날짜에도 제 티켓이 유효한가요?)</span>

<mark>M</mark>: Yes, your tickets will be honored, but if you can't attend, we can issue a <mark>refund or exchange</mark> them for another date.
<span class="translation">(네, 티켓은 유효하지만, 참석이 어려우시다면 환불이나 다른 날짜로 교환해드릴 수 있습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "Why is <mark>the man</mark> calling the woman?",
        options: {
          A: "To confirm her attendance at a <mark>theater event</mark>",
          B: "To notify her of a <mark>schedule change</mark>",
          C: "To offer her <mark>discounted</mark> <mark>tickets</mark>",
          D: "To ask for <mark>payment</mark> <mark>confirmation</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) To notify her of a schedule change

대본 키워드: "Unfortunately, that performance has been rescheduled to June 17."
보기 키워드: "To notify her of a schedule change"

❌ 오답 트랩:
(A) To confirm her attendance at a theater event 
→ 참석 확인이 아닌 일정 변경 통보

(C) To offer her discounted tickets 
→ 할인 티켓 제안 언급 없음

(D) To ask for payment confirmation 
→ 결제 확인 요청 언급 없음`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> ask about?",
        options: {
          A: "Whether her <mark>tickets</mark> will still be <mark>valid</mark>",
          B: "If she can change her <mark>seat</mark> <mark>location</mark>",
          C: "Whether she can get <mark>additional</mark> <mark>tickets</mark>",
          D: "If there will be a <mark>different cast</mark> performing",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Whether her tickets will still be valid

대본 키워드: "Are my tickets still valid for the new date?"
보기 키워드: "Whether her tickets will still be valid"

❌ 오답 트랩:
(B) If she can change her seat location 
→ 좌석 변경 문의 없음

(C) Whether she can get additional tickets 
→ 추가 티켓 구매 문의 없음

(D) If there will be a different cast performing 
→ 출연진 변경 문의 없음`,
      },
      {
        id: 3,
        question: "What alternative option does <mark>the man</mark> offer?",
        options: {
          A: "A free upgrade to <mark>VIP</mark> <mark>seats</mark>",
          B: "A <mark>refund</mark> or ticket <mark>exchange</mark>",
          C: "A <mark>backstage tour</mark> after the show",
          D: "Complimentary <mark>drinks</mark> at the venue",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A refund or ticket exchange

대본 키워드: "If you can't attend, we can issue a refund or exchange them for another date."
보기 키워드: "A refund or ticket exchange"

❌ 오답 트랩:
(A) A free upgrade to VIP seats 
→ VIP 좌석 업그레이드 제안 없음

(C) A backstage tour after the show 
→ 백스테이지 투어 제안 없음

(D) Complimentary drinks at the venue 
→ 무료 음료 제공 언급 없음`,
      },
    ],
  },
  conversation2: {
    id: 2,
    title: "Ticket Reservation & Pricing Inquiry",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure2.mp3",
        script: `<mark>M</mark>: Hi, I'd like to book two tickets for the National History Museum this Saturday. Can I purchase them online?
<span class="translation">(안녕하세요, 이번 토요일 국립역사박물관 티켓 두 장을 예약하고 싶은데요. 온라인으로 구매할 수 있나요?)</span>

<mark>W</mark>: Yes, you can. We recommend booking in advance, as <mark>weekends tend to be busy</mark>.
<span class="translation">(네, 가능합니다. 주말에는 보통 혼잡하니 미리 예약하시는 것을 추천드립니다.)</span>

<mark>M</mark>: I see. Are there any discounts available?
<span class="translation">(알겠습니다. 할인 혜택이 있나요?)</span>

<mark>W</mark>: Yes, students and seniors get a discount, but they'll need to show a valid <mark>ID</mark> at the entrance.
<span class="translation">(네, 학생과 노인분들은 할인을 받으실 수 있지만, 입구에서 유효한 신분증을 보여주셔야 합니다.)</span>

<mark>M</mark>: That's good to know. What about guided tours?
<span class="translation">(알아두면 좋네요. 가이드 투어는 어떻게 되나요?)</span>

<mark>W</mark>: They are offered <mark>twice a day</mark>, in the morning and afternoon. You can sign up when you arrive.
<span class="translation">(오전과 오후에 하루 두 번 제공됩니다. 도착하셔서 신청하실 수 있어요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "Why does <mark>the woman</mark> suggest booking in advance?",
        options: {
          A: "The museum is <mark>closed</mark> on <mark>weekends</mark>",
          B: "Tickets are more expensive at the <mark>door</mark>",
          C: "The museum is usually <mark>crowded</mark> on <mark>weekends</mark>",
          D: "Online bookings come with free <mark>guided</mark> <mark>tours</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) The museum is usually crowded on weekends

대본 키워드: "We recommend booking in advance, as weekends tend to be busy."
보기 키워드: "The museum is usually crowded on weekends"

❌ 오답 트랩:
(A) The museum is closed on weekends 
→ 주말에 혼잡하다는 내용은 있지만 폐점 관련 언급 없음

(B) Tickets are more expensive at the door 
→ 가격 차이 관련 언급 없음

(D) Online bookings come with free guided tours 
→ 온라인 예약 혜택 관련 내용 없음`,
      },
      {
        id: 2,
        question: "What must visitors do to receive a <mark>discount</mark>?",
        options: {
          A: "Arrive before <mark>noon</mark>",
          B: "Show <mark>identification</mark>",
          C: "<mark>Purchase tickets</mark> at the entrance",
          D: "Visit on a <mark>weekday</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Show identification

대본 키워드: "Students and seniors get a discount, but they'll need to show a valid ID at the entrance."
보기 키워드: "Show identification"

❌ 오답 트랩:
(A) Arrive before noon 
→ 도착 시간 관련 할인 언급 없음

(C) Purchase tickets at the entrance 
→ 입구에서 구매 시 할인 언급 없음

(D) Visit on a weekday 
→ 평일 방문 할인 언급 없음`,
      },
      {
        id: 3,
        question:
          "What does <mark>the woman</mark> say about <mark>guided tours</mark>?",
        options: {
          A: "They are available <mark>twice a day</mark>",
          B: "They require an <mark>additional</mark> <mark>fee</mark>",
          C: "They must be booked <mark>online</mark>",
          D: "They are <mark>only</mark> for <mark>group</mark> <mark>visitors</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) They are available twice a day

대본 키워드: "They are offered twice a day, in the morning and afternoon."
보기 키워드: "They are available twice a day"

❌ 오답 트랩:
(B) They require an additional fee 
→ 추가 요금 관련 언급 없음

(C) They must be booked online 
→ 도착 시 신청 가능하다고 언급

(D) They are only for group visitors 
→ 단체 관람객 전용이라는 언급 없음`,
      },
    ],
  },
  conversation3: {
    id: 3,
    title: "Membership Registration & Pricing Inquiry",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure3.mp3",
        script: `<mark>W</mark>: Hi, I'm interested in joining your fitness center. Can you tell me about the <mark>membership options</mark>?
<span class="translation">(안녕하세요, 피트니스 센터 가입에 관심이 있는데요. 멤버십 옵션에 대해 알려주실 수 있나요?)</span>

<mark>M</mark>: Sure! We offer both monthly and annual memberships. The annual plan includes additional benefits like free locker use.
<span class="translation">(물론이죠! 월간과 연간 멤버십을 제공하고 있어요. 연간 플랜에는 무료 락커 이용과 같은 추가 혜택이 포함됩니다.)</span>

<mark>W</mark>: That sounds great. Are there any special promotions going on right now?
<span class="translation">(좋네요. 현재 진행 중인 특별 프로모션이 있나요?)</span>

<mark>M</mark>: Yes! If you sign up this week, you get a <mark>10% discount on your first three months</mark>.
<span class="translation">(네! 이번 주에 가입하시면 첫 3개월 동안 10% 할인을 받으실 수 있습니다.)</span>

<mark>W</mark>: That's a good deal. I'll sign up for the annual membership. How do I complete the registration?
<span class="translation">(좋은 혜택이네요. 연간 멤버십으로 가입할게요. 등록은 어떻게 하면 되나요?)</span>

<mark>M</mark>: You can <mark>register online or fill out a form at the front desk</mark>.
<span class="translation">(온라인으로 등록하시거나 프런트 데스크에서 양식을 작성하실 수 있습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the woman</mark> asking about?",
        options: {
          A: "<mark>Personal training</mark> sessions",
          B: "<mark>Gym membership</mark> options",
          C: "<mark>Group</mark> fitness <mark>classes</mark>",
          D: "<mark>Locker room</mark> facilities",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Gym membership options

대본 키워드: "Can you tell me about the membership options?"
보기 키워드: "Gym membership options"

❌ 오답 트랩:
(A) Personal training sessions 
→ 트레이닝 세션이 아닌 멤버십 문의 중

(C) Group fitness classes 
→ 단체 수업 관련 문의 없음

(D) Locker room facilities 
→ 락커 이용 언급은 있지만, 질문 초점이 아님`,
      },
      {
        id: 2,
        question: "What promotional offer is available?",
        options: {
          A: "A free <mark>one-month</mark> trial",
          B: "A discount on the first <mark>three</mark> <mark>months</mark>",
          C: "A <mark>personal training</mark> session included",
          D: "Access to <mark>all</mark> <mark>gym</mark> <mark>locations</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A discount on the first three months

대본 키워드: "If you sign up this week, you get a 10% discount on your first three months."
보기 키워드: "A discount on the first three months"

❌ 오답 트랩:
(A) A free one-month trial 
→ 무료 체험 제공 언급 없음

(C) A personal training session included 
→ 트레이닝 세션 포함 언급 없음

(D) Access to all gym locations 
→ 모든 지점 이용 가능 언급 없음`,
      },
      {
        id: 3,
        question: "How can <mark>the woman</mark> complete her registration?",
        options: {
          A: "By calling the <mark>customer service</mark> line",
          B: "By filling out a form at the <mark>front desk</mark> or <mark>online</mark>",
          C: "By scheduling an appointment with a <mark>trainer</mark>",
          D: "By paying the registration fee in <mark>cash only</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) By filling out a form at the front desk or online

대본 키워드: "You can register online or fill out a form at the front desk."
보기 키워드: "By filling out a form at the front desk or online"

❌ 오답 트랩:
(A) By calling the customer service line 
→ 고객 서비스 라인 통화 언급 없음

(C) By scheduling an appointment with a trainer 
→ 트레이너 예약 언급 없음

(D) By paying the registration fee in cash only 
→ 현금 결제만 가능하다는 언급 없음`,
      },
    ],
  },
  conversation4: {
    id: 4,
    title: "Available Facilities & Operating Hours",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure4.mp3",
        script: `<mark>M</mark>: Hi, I recently joined your gym. What time does the fitness center <mark>open</mark>?
<span class="translation">(안녕하세요, 최근에 헬스장에 가입했는데요. 피트니스 센터는 몇 시에 여나요?)</span>

<mark>W</mark>: We're open from 6 AM to 10 PM on weekdays and 8 AM to 8 PM on weekends.
<span class="translation">(평일에는 오전 6시부터 오후 10시까지, 주말에는 오전 8시부터 오후 8시까지 운영합니다.)</span>

<mark>M</mark>: Great! What facilities are available?
<span class="translation">(좋네요! 어떤 시설들이 있나요?)</span>

<mark>W</mark>: We have a weight training area, a swimming pool, an <mark>indoor running track</mark>, and several group class studios.
<span class="translation">(웨이트 트레이닝 구역, 수영장, 실내 러닝 트랙, 그리고 여러 그룹 수업 스튜디오가 있습니다.)</span>

<mark>M</mark>: That's a lot of options. Do I need to reserve a spot for the group classes?
<span class="translation">(선택할 수 있는 게 많네요. 그룹 수업은 예약해야 하나요?)</span>

<mark>W</mark>: Yes, for popular classes like yoga and cycling, we recommend <mark>booking at least a day in advance</mark>.
<span class="translation">(네, 요가나 사이클링 같은 인기 수업은 최소 하루 전에 예약하시는 것을 추천드립니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the man</mark> asking about first?",
        options: {
          A: "The <mark>gym's</mark> <mark>opening</mark> <mark>hours</mark>",
          B: "The cost of <mark>membership</mark>",
          C: "The availability of <mark>personal</mark> <mark>trainers</mark>",
          D: "The <mark>location</mark> of the gym",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) The gym's opening hours

대본 키워드: "What time does the fitness center open?"
보기 키워드: "The gym's opening hours"

❌ 오답 트랩:
(B) The cost of membership 
→ 멤버십 비용 문의 없음

(C) The availability of personal trainers 
→ 개인 트레이너 관련 문의 없음

(D) The location of the gym 
→ 위치 관련 문의 없음`,
      },
      {
        id: 2,
        question: "Which facility is mentioned?",
        options: {
          A: "A <mark>rock climbing</mark> wall",
          B: "An <mark>indoor running</mark> track",
          C: "A <mark>steam</mark> <mark>room</mark>",
          D: "An <mark>outdoor</mark> <mark>pool</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) An indoor running track

대본 키워드: "We have a weight training area, a swimming pool, an indoor running track, and several group class studios."
보기 키워드: "An indoor running track"

❌ 오답 트랩:
(A) A rock climbing wall 
→ 암벽등반 시설 언급 없음

(C) A steam room 
→ 스팀룸 언급 없음

(D) An outdoor pool 
→ 실외 수영장이 아닌 일반 수영장 언급`,
      },
      {
        id: 3,
        question:
          "What does <mark>the woman</mark> recommend for popular classes?",
        options: {
          A: "Signing up at least a day <mark>in</mark> <mark>advance</mark>",
          B: "Arriving <mark>30 minutes</mark> early",
          C: "Bringing your <mark>own</mark> <mark>equipment</mark>",
          D: "Attending during <mark>off-peak</mark> <mark>hours</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Signing up at least a day in advance

대본 키워드: "For popular classes like yoga and cycling, we recommend booking at least a day in advance."
보기 키워드: "Signing up at least a day in advance"

❌ 오답 트랩:
(B) Arriving 30 minutes early 
→ 일찍 도착 권장 언급 없음

(C) Bringing your own equipment 
→ 개인 장비 지참 언급 없음

(D) Attending during off-peak hours 
→ 한산한 시간대 이용 권장 언급 없음`,
      },
    ],
  },
  conversation5: {
    id: 5,
    title: "Class Booking & Trainer Consultation",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure5.mp3",
        script: `<mark>W</mark>: Hi, I'd like to book a personal training session for next week. How can I do that?
<span class="translation">(안녕하세요, 다음 주에 개인 트레이닝 세션을 예약하고 싶은데요. 어떻게 하면 될까요?)</span>

<mark>M</mark>: You can book it through our mobile app or at the front desk.
<span class="translation">(모바일 앱이나 프런트 데스크에서 예약하실 수 있습니다.)</span>

<mark>W</mark>: I see. Are there beginner-friendly classes available?
<span class="translation">(알겠습니다. 초보자를 위한 수업도 있나요?)</span>

<mark>M</mark>: Yes! We have an <mark>introductory strength training class every Monday</mark> and a <mark>flexibility class on Wednesdays</mark>.
<span class="translation">(네! 매주 월요일에 입문자를 위한 근력 운동 수업이 있고, 수요일에는 유연성 수업이 있습니다.)</span>

<mark>W</mark>: That sounds perfect. Can I book both classes now?
<span class="translation">(완벽하네요. 두 수업 모두 지금 예약할 수 있나요?)</span>

<mark>M</mark>: <mark>Of course! I'll add them to your schedule</mark>.
<span class="translation">(물론이죠! 일정에 추가해드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What does <mark>the woman</mark> want to do?",
        options: {
          A: "Sign up for a <mark>personal training</mark> session",
          B: "Request a membership <mark>refund</mark>",
          C: "Purchase <mark>new</mark> <mark>workout</mark> <mark>gear</mark>",
          D: "Take a facility <mark>tour</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Sign up for a personal training session

대본 키워드: "I'd like to book a personal training session for next week."
보기 키워드: "Sign up for a personal training session"

❌ 오답 트랩:
(B) Request a membership refund 
→ 환불 요청 언급 없음

(C) Purchase new workout gear 
→ 운동 장비 구매 언급 없음

(D) Take a facility tour 
→ 시설 투어 언급 없음`,
      },
      {
        id: 2,
        question: "What type of classes are available?",
        options: {
          A: "<mark>Dance</mark> and <mark>boxing</mark>",
          B: "<mark>Strength</mark> training and <mark>flexibility</mark>",
          C: "<mark>Martial</mark> arts and <mark>swimming</mark>",
          D: "<mark>Cycling</mark> and <mark>pilates</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Strength training and flexibility

대본 키워드: "We have an introductory strength training class every Monday and a flexibility class on Wednesdays."
보기 키워드: "Strength training and flexibility"

❌ 오답 트랩:
(A) Dance and boxing 
→ 댄스와 복싱 수업 언급 없음

(C) Martial arts and swimming 
→ 무술과 수영 수업 언급 없음

(D) Cycling and pilates 
→ 사이클링과 필라테스 수업 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> do next?",
        options: {
          A: "<mark>Add</mark> the classes to her <mark>schedule</mark>",
          B: "Give her a <mark>facility</mark> <mark>tour</mark>",
          C: "Recommend <mark>personal trainers</mark>",
          D: "Process a <mark>payment</mark> for the classes",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Add the classes to her schedule
      
      대본 키워드: "I'll add them to your schedule."
      보기 키워드: "Add the classes to her schedule"
      
      ❌ 오답 트랩:
      (B) Give her a facility tour 
      → 시설 투어 언급 없음
      
      (C) Recommend personal trainers 
      → 개인 트레이너 추천 언급 없음
      
      (D) Process a payment for the classes 
      → 수업 결제 언급 없음`,
      },
    ],
  },
  conversation6: {
    id: 6,
    title: "Amusement Park Hours & Facility Information",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure6.mp3",
        script: `<mark>W</mark>: Hi, I'm planning a trip to Wonderland Amusement Park next week. What are your <mark>operating hours</mark>?
<span class="translation">(안녕하세요, 다음 주에 원더랜드 놀이공원에 가려고 하는데요. 운영 시간이 어떻게 되나요?)</span>

<mark>M</mark>: We're open from 9 AM to 8 PM on weekdays and until 10 PM on weekends.
<span class="translation">(평일에는 오전 9시부터 오후 8시까지, 주말에는 오후 10시까지 운영합니다.)</span>

<mark>W</mark>: That's great. Are all the rides open during those hours?
<span class="translation">(좋네요. 모든 놀이기구가 그 시간 동안 운영되나요?)</span>

<mark>M</mark>: Most of them, yes. But the <mark>water rides close an hour earlier</mark> than the rest of the park.
<span class="translation">(대부분은 그렇습니다. 하지만 물놀이 기구는 다른 시설보다 한 시간 일찍 운영을 종료합니다.)</span>

<mark>W</mark>: I see. Is there a dining area inside the park?
<span class="translation">(알겠습니다. 공원 내에 식사 공간이 있나요?)</span>

<mark>M</mark>: Yes, there are several food courts and restaurants, and <mark>guests are also allowed to bring their own food</mark>.
<span class="translation">(네, 여러 푸드코트와 레스토랑이 있고, 손님들이 직접 음식을 가져오시는 것도 가능합니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What does <mark>the woman</mark> ask about first?",
        options: {
          A: "The <mark>location</mark> of the park",
          B: "The <mark>cost</mark> of admission",
          C: "The operating <mark>hours</mark>",
          D: "The <mark>parking</mark> facilities",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) The operating hours

대본 키워드: "What are your operating hours?"
보기 키워드: "The operating hours"

❌ 오답 트랩:
(A) The location of the park 
→ 위치 문의 없음

(B) The cost of admission 
→ 입장료 문의 없음

(D) The parking facilities 
→ 주차 시설 문의 없음`,
      },
      {
        id: 2,
        question: "What is mentioned about the park's water rides?",
        options: {
          A: "They require an <mark>additional</mark> <mark>ticket</mark>",
          B: "They are only available in the <mark>summer</mark>",
          C: "They <mark>close earlier</mark> than other rides",
          D: "They are not included in the <mark>general admission</mark> price",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) They close earlier than other rides

대본 키워드: "The water rides close an hour earlier than the rest of the park."
보기 키워드: "They close earlier than other rides"

❌ 오답 트랩:
(A) They require an additional ticket 
→ 추가 티켓 필요 언급 없음

(B) They are only available in the summer 
→ 여름 한정 운영 언급 없음

(D) They are not included in the general admission price 
→ 입장료 미포함 언급 없음`,
      },
      {
        id: 3,
        question: "What does <mark>the man</mark> say about food options?",
        options: {
          A: "<mark>Outside food</mark> is <mark>not allowed</mark>",
          B: "There is <mark>only one</mark> dining area",
          C: "Guests can bring their <mark>own</mark> <mark>food</mark>",
          D: "Food is included in the <mark>admission</mark> <mark>price</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Guests can bring their own food

대본 키워드: "Guests are also allowed to bring their own food."
보기 키워드: "Guests can bring their own food"

❌ 오답 트랩:
(A) Outside food is not allowed 
→ 외부 음식이 허용된다고 명시됨

(B) There is only one dining area 
→ 여러 푸드코트와 레스토랑이 있다고 언급

(D) Food is included in the admission price 
→ 입장료 포함 여부 언급 없음`,
      },
    ],
  },
  conversation7: {
    id: 7,
    title: "Ticket Options & Membership Benefits",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure7.mp3",
        script: `<mark>M</mark>: Hi, I'm interested in visiting Adventure Park this summer. What <mark>ticket options</mark> do you offer?
<span class="translation">(안녕하세요, 이번 여름에 어드벤처 파크에 가보고 싶은데요. 어떤 티켓 옵션이 있나요?)</span>

<mark>W</mark>: We have single-day passes, family packages, and annual memberships.
<span class="translation">(1일 이용권, 가족 패키지, 그리고 연간 멤버십이 있습니다.)</span>

<mark>M</mark>: That's good to know. What are the benefits of the membership?
<span class="translation">(알아두면 좋네요. 멤버십의 혜택은 어떤 것들이 있나요?)</span>

<mark>W</mark>: Members get unlimited entry, <mark>discounts on food and merchandise</mark>, and early access to new rides.
<span class="translation">(멤버는 무제한 입장, 음식과 상품 할인, 그리고 새로운 놀이기구를 먼저 이용할 수 있는 혜택이 있습니다.)</span>

<mark>M</mark>: Sounds great. Can I upgrade my single-day ticket to a membership later?
<span class="translation">(좋네요. 나중에 1일 이용권을 멤버십으로 업그레이드할 수 있나요?)</span>

<mark>W</mark>: Yes, as long as you do it <mark>on the same day</mark> of your visit.
<span class="translation">(네, 방문하신 당일에 하시면 가능합니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of discussion?",
        options: {
          A: "A <mark>theme park</mark> expansion",
          B: "A <mark>new attraction</mark> opening",
          C: "<mark>Ticket</mark> options <mark>and</mark> <mark>membership</mark> benefits",
          D: "<mark>Safety regulations</mark> at the park",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Ticket options and membership benefits

대본 키워드: "What ticket options do you offer?" & "What are the benefits of the membership?"
보기 키워드: "Ticket options and membership benefits"

❌ 오답 트랩:
(A) A theme park expansion 
→ 놀이공원 확장 논의 없음

(B) A new attraction opening 
→ 새로운 어트랙션 오픈 논의 없음

(D) Safety regulations at the park 
→ 안전 규정 논의 없음`,
      },
      {
        id: 2,
        question: "What is one of the benefits of the membership?",
        options: {
          A: "<mark>Free parking</mark> for members",
          B: "Exclusive access to <mark>VIP</mark> areas",
          C: "<mark>Discounts</mark> on food and merchandise",
          D: "<mark>Priority boarding</mark> on <mark>all rides</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Discounts on food and merchandise

대본 키워드: "Members get unlimited entry, discounts on food and merchandise, and early access to new rides."
보기 키워드: "Discounts on food and merchandise"

❌ 오답 트랩:
(A) Free parking for members 
→ 무료 주차 혜택 언급 없음

(B) Exclusive access to VIP areas 
→ VIP 구역 접근 혜택 언급 없음

(D) Priority boarding on all rides 
→ 모든 놀이기구 우선 탑승 언급 없음, 새로운 놀이기구만 가능`,
      },
      {
        id: 3,
        question: "What condition is mentioned about upgrading a ticket?",
        options: {
          A: "The upgrade must be done on the <mark>same day</mark>",
          B: "It can <mark>only</mark> be done <mark>online</mark>",
          C: "It requires a <mark>separate</mark> <mark>application</mark>",
          D: "A <mark>minimum</mark> of <mark>three tickets</mark> must be purchased",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) The upgrade must be done on the same day

대본 키워드: "Yes, as long as you do it on the same day of your visit."
보기 키워드: "The upgrade must be done on the same day"

❌ 오답 트랩:
(B) It can only be done online 
→ 온라인 전용 업그레이드 언급 없음

(C) It requires a separate application 
→ 별도 신청서 필요 언급 없음

(D) A minimum of three tickets must be purchased 
→ 최소 구매 수량 언급 없음`,
      },
    ],
  },
  conversation8: {
    id: 8,
    title: "Check-in Requests",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure8.mp3",
        script: `<mark>M</mark>: Hi, I have a reservation at The Grandview Hotel for tonight. What time is <mark>check-in</mark>?
<span class="translation">(안녕하세요, 오늘 밤 그랜드뷰 호텔 예약이 되어있는데요. 체크인은 몇 시부터인가요?)</span>

<mark>W</mark>: Check-in starts at 3 PM, but we might have some rooms available earlier. Would you like an <mark>early check-in</mark>?
<span class="translation">(체크인은 오후 3시부터 시작하지만, 일찍 이용 가능한 객실이 있을 수 있습니다. 얼리 체크인을 원하시나요?)</span>

<mark>M</mark>: That would be great. Is there an additional charge for that?
<span class="translation">(좋네요. 추가 요금이 있나요?)</span>

<mark>W</mark>: Yes, early check-in before 1 PM costs an extra $20.
<span class="translation">(네, 오후 1시 이전 얼리 체크인은 20달러가 추가됩니다.)</span>

<mark>M</mark>: I see. I'll <mark>wait until the standard check-in time</mark>, then.
<span class="translation">(알겠습니다. 그럼 일반 체크인 시간까지 기다리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the man</mark> asking about?",
        options: {
          A: "The hotel's <mark>cancellation</mark> <mark>policy</mark>",
          B: "The <mark>check-in</mark> <mark>time</mark>",
          C: "The availability of <mark>late</mark> <mark>check-out</mark>",
          D: "<mark>Room upgrade</mark> options",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The check-in time

대본 키워드: "What time is check-in?"
보기 키워드: "The check-in time"

❌ 오답 트랩:
(A) The hotel's cancellation policy 
→ 취소 정책 문의 없음

(C) The availability of late check-out 
→ 늦은 체크아웃 문의 없음

(D) Room upgrade options 
→ 객실 업그레이드 문의 없음`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> offer?",
        options: {
          A: "A complimentary <mark>breakfast</mark>",
          B: "A free room <mark>upgrade</mark>",
          C: "An <mark>early check-in</mark> for an additional fee",
          D: "A <mark>shuttle</mark> service to the airport",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) An early check-in for an additional fee

대본 키워드: "Early check-in before 1 PM costs an extra $20."
보기 키워드: "An early check-in for an additional fee"

❌ 오답 트랩:
(A) A complimentary breakfast 
→ 무료 조식 제공 언급 없음

(B) A free room upgrade 
→ 무료 객실 업그레이드 제안 없음

(D) A shuttle service to the airport 
→ 공항 셔틀 서비스 언급 없음`,
      },
      {
        id: 3,
        question: "What does <mark>the man</mark> decide to do?",
        options: {
          A: "<mark>Pay</mark> for early check-in",
          B: "Wait until the <mark>standard</mark> check-in time",
          C: "<mark>Change</mark> his reservation to another <mark>date</mark>",
          D: "Request a <mark>late</mark> <mark>check-out</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Wait until the standard check-in time

대본 키워드: "I'll wait until the standard check-in time, then."
보기 키워드: "Wait until the standard check-in time"

❌ 오답 트랩:
(A) Pay for early check-in 
→ 얼리 체크인 비용 지불 거절함

(C) Change his reservation to another date 
→ 예약 날짜 변경 언급 없음

(D) Request a late check-out 
→ 늦은 체크아웃 요청 없음`,
      },
    ],
  },
  conversation9: {
    id: 9,
    title: "Late Check-out Inquiry",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure9.mp3",
        script: `<mark>W</mark>: Hi, I have a reservation under Lisa Parker, and I'm supposed to check out tomorrow. Is it possible to extend my <mark>check-out time</mark>?
<span class="translation">(안녕하세요, Lisa Parker로 예약되어 있고 내일 체크아웃 예정인데요. 체크아웃 시간을 연장할 수 있을까요?)</span>

<mark>M</mark>: Let me check. Our standard check-out is at 11 AM, but we allow <mark>late check-outs until 2 PM</mark> for an additional charge.
<span class="translation">(확인해보겠습니다. 일반 체크아웃은 오전 11시이지만, 추가 요금을 내시면 오후 2시까지 늦은 체크아웃이 가능합니다.)</span>

<mark>W</mark>: That would be helpful. How much does it cost?
<span class="translation">(도움이 될 것 같네요. 비용은 얼마인가요?)</span>

<mark>M</mark>: It's $30 for a late check-out. Would you like me to add that to your booking?
<span class="translation">(늦은 체크아웃은 30달러입니다. 예약에 추가해드릴까요?)</span>

<mark>W</mark>: Actually, I'll try to <mark>leave by 11 AM as planned</mark>. Thanks for the info!
<span class="translation">(사실, 계획대로 오전 11시까지 나가도록 하겠습니다. 정보 감사합니다!)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What does <mark>the woman</mark> request?",
        options: {
          A: "A late <mark>check-out</mark>",
          B: "A complimentary room <mark>upgrade</mark>",
          C: "An <mark>additional night's</mark> stay",
          D: "A different room with a better <mark>view</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A late check-out

대본 키워드: "Is it possible to extend my check-out time?"
보기 키워드: "A late check-out"

❌ 오답 트랩:
(B) A complimentary room upgrade 
→ 무료 객실 업그레이드 요청 없음

(C) An additional night's stay 
→ 추가 숙박 요청 없음

(D) A different room with a better view 
→ 다른 전망의 객실 요청 없음`,
      },
      {
        id: 2,
        question:
          "What does <mark>the man</mark> say about the late check-out policy?",
        options: {
          A: "It is available at <mark>no extra cost</mark>",
          B: "It is only available for <mark>VIP</mark> guests",
          C: "It is allowed until <mark>2 PM</mark> for an <mark>additional fee</mark>",
          D: "It requires a minimum stay of <mark>two</mark> <mark>nights</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) It is allowed until 2 PM for an additional fee

대본 키워드: "We allow late check-outs until 2 PM for an additional charge."
보기 키워드: "It is allowed until 2 PM for an additional fee"

❌ 오답 트랩:
(A) It is available at no extra cost 
→ 추가 비용이 있다고 언급됨

(B) It is only available for VIP guests 
→ VIP 전용이라는 언급 없음

(D) It requires a minimum stay of two nights 
→ 최소 숙박 기간 언급 없음`,
      },
      {
        id: 3,
        question: "What does <mark>the woman</mark> decide to do?",
        options: {
          A: "<mark>Pay</mark> for the late check-out",
          B: "<mark>Check out</mark> at the <mark>regular time</mark>",
          C: "Stay <mark>another night</mark> at the hotel",
          D: "<mark>Change</mark> her check-in <mark>date</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Check out at the regular time

대본 키워드: "Actually, I'll try to leave by 11 AM as planned."
보기 키워드: "Check out at the regular time"

❌ 오답 트랩:
(A) Pay for the late check-out 
→ 늦은 체크아웃 비용 지불 거절함

(C) Stay another night at the hotel 
→ 추가 숙박 결정 없음

(D) Change her check-in date 
→ 체크인 날짜 변경 없음`,
      },
    ],
  },
  conversation10: {
    id: 10,
    title: "Room Change Request",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure10.mp3",
        script: `<mark>M</mark>: Hi, I just checked into room 305, but I'd like to switch to a different room. Is that possible?
<span class="translation">(안녕하세요, 방금 305호에 체크인했는데 다른 방으로 바꾸고 싶습니다. 가능할까요?)</span>

<mark>W</mark>: Sure. May I ask why you'd like to change rooms?
<span class="translation">(네. 방을 바꾸시려는 이유를 여쭤봐도 될까요?)</span>

<mark>M</mark>: The room is facing the street, and the <mark>noise is a bit too loud</mark>.
<span class="translation">(방이 거리를 향하고 있어서 소음이 좀 심합니다.)</span>

<mark>W</mark>: I understand. We have a quieter room available on the <mark>opposite side of the hotel</mark>. Would you like to switch to that one?
<span class="translation">(이해했습니다. 호텔 반대편에 더 조용한 방이 있는데요. 그쪽으로 바꾸시겠습니까?)</span>

<mark>M</mark>: Yes, that sounds much better. Is there any extra charge for the change?
<span class="translation">(네, 그게 훨씬 좋겠네요. 변경에 추가 요금이 있나요?)</span>

<mark>W</mark>: No, it's the same room type, so there is <mark>no additional fee</mark>. I'll arrange the transfer now.
<span class="translation">(아니요, 같은 객실 타입이라 추가 요금이 없습니다. 지금 바로 이전을 준비하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "Why does <mark>the man</mark> want to change rooms?",
        options: {
          A: "His room is too <mark>small</mark>",
          B: "The <mark>air conditioning</mark> is broken",
          C: "The room is too <mark>noisy</mark>",
          D: "The <mark>Wi-Fi</mark> connection is unstable",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) The room is too noisy

대본 키워드: "The room is facing the street, and the noise is a bit too loud."
보기 키워드: "The room is too noisy"

❌ 오답 트랩:
(A) His room is too small 
→ 방 크기 관련 언급 없음

(B) The air conditioning is broken 
→ 에어컨 고장 언급 없음

(D) The Wi-Fi connection is unstable 
→ 와이파이 연결 문제 언급 없음`,
      },
      {
        id: 2,
        question: "What alternative does <mark>the woman</mark> offer?",
        options: {
          A: "A <mark>larger</mark> suite at a <mark>discounted</mark> price",
          B: "A room on the <mark>opposite</mark> side of the hotel",
          C: "A room with a <mark>city</mark> <mark>view</mark>",
          D: "A refund for the <mark>first night</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A room on the opposite side of the hotel

대본 키워드: "We have a quieter room available on the opposite side of the hotel."
보기 키워드: "A room on the opposite side of the hotel"

❌ 오답 트랩:
(A) A larger suite at a discounted price 
→ 할인된 스위트룸 제안 없음

(C) A room with a city view 
→ 도시 전망 객실 언급 없음

(D) A refund for the first night 
→ 첫날 환불 제안 없음`,
      },
      {
        id: 3,
        question: "What does <mark>the woman</mark> say about the room change?",
        options: {
          A: "It requires an <mark>additional</mark> <mark>charge</mark>",
          B: "It is only available for <mark>one</mark> <mark>night</mark>",
          C: "It does <mark>not</mark> <mark>cost</mark> extra",
          D: "It will <mark>take</mark> some <mark>time</mark> to arrange",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) It does not cost extra

대본 키워드: "No, it's the same room type, so there is no additional fee."
보기 키워드: "It does not cost extra"

❌ 오답 트랩:
(A) It requires an additional charge 
→ 추가 요금이 없다고 명시됨

(B) It is only available for one night 
→ 하룻밤 한정이라는 언급 없음

(D) It will take some time to arrange 
→ 바로 이전을 준비하겠다고 함`,
      },
    ],
  },
  conversation11: {
    id: 11,
    title: "Insurance Options Inquiry",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure11.mp3",
        script: `<mark>M</mark>: Hi, I'm renting a car for the weekend. What <mark>insurance options</mark> do you offer?
<span class="translation">(안녕하세요, 주말에 차를 렌트하려고 하는데요. 어떤 보험 옵션이 있나요?)</span>

<mark>W</mark>: We have three coverage plans. Basic coverage includes liability insurance only, while the standard and premium plans cover additional damage protection.
<span class="translation">(세 가지 보험 플랜이 있습니다. 기본 보험은 책임 보험만 포함되고, 스탠다드와 프리미엄 플랜은 추가 손해 보상이 포함됩니다.)</span>

<mark>M</mark>: What's the difference between standard and premium?
<span class="translation">(스탠다드와 프리미엄의 차이가 뭔가요?)</span>

<mark>W</mark>: The <mark>premium plan covers theft and roadside assistance</mark>, while the standard plan does not.
<span class="translation">(프리미엄 플랜은 도난과 긴급출동 서비스가 포함되지만, 스탠다드 플랜은 포함되지 않습니다.)</span>

<mark>M</mark>: I see. I'll go with the <mark>premium plan</mark>, just in case.
<span class="translation">(알겠습니다. 혹시 모르니 프리미엄 플랜으로 하겠습니다.)</span>

<mark>W</mark>: Good choice. I'll add that to your reservation now.
<span class="translation">(좋은 선택이네요. 지금 예약에 추가해드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the man</mark> asking about?",
        options: {
          A: "<mark>Fuel</mark> <mark>policy</mark>",
          B: "<mark>Insurance</mark> options",
          C: "<mark>Rental</mark> <mark>duration</mark>",
          D: "Car <mark>availability</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Insurance options

대본 키워드: "What insurance options do you offer?"
보기 키워드: "Insurance options"

❌ 오답 트랩:
(A) Fuel policy 
→ 연료 정책 문의 없음

(C) Rental duration 
→ 렌트 기간 문의 없음

(D) Car availability 
→ 차량 가용성 문의 없음`,
      },
      {
        id: 2,
        question:
          "How does <mark>the premium plan</mark> differ from the standard plan?",
        options: {
          A: "<mark>Liability</mark> insurance <mark>only</mark>",
          B: "<mark>Theft</mark> protection and <mark>roadside</mark> assistance",
          C: "A <mark>discount</mark> on long-term rentals",
          D: "A <mark>free</mark> vehicle <mark>upgrade</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Theft protection and roadside assistance

대본 키워드: "The premium plan covers theft and roadside assistance"
보기 키워드: "Theft protection and roadside assistance"

❌ 오답 트랩:
(A) Liability insurance only 
→ 기본 플랜의 특징임

(C) A discount on long-term rentals 
→ 장기 렌트 할인 언급 없음

(D) A free vehicle upgrade 
→ 무료 차량 업그레이드 언급 없음`,
      },
      {
        id: 3,
        question: "What does <mark>the man</mark> decide to do?",
        options: {
          A: "Choose the <mark>premium</mark> insurance plan",
          B: "<mark>Decline all</mark> insurance coverage",
          C: "<mark>Extend</mark> his rental <mark>period</mark>",
          D: "<mark>Switch</mark> to a <mark>larger</mark> vehicle",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Choose the premium insurance plan

대본 키워드: "I'll go with the premium plan, just in case."
보기 키워드: "Choose the premium insurance plan"

❌ 오답 트랩:
(B) Decline all insurance coverage 
→ 보험을 거절하지 않고 프리미엄 선택함

(C) Extend his rental period 
→ 렌트 기간 연장 언급 없음

(D) Switch to a larger vehicle 
→ 더 큰 차량으로 변경 언급 없음`,
      },
    ],
  },

  conversation12: {
    id: 12,
    title: "Special Request - Vegetarian Options",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure12.mp3",
        script: `<mark>W</mark>: Hi, I don't eat meat. Do you have <mark>vegetarian options</mark> on the menu?
<span class="translation">(안녕하세요, 저는 고기를 먹지 않는데요. 메뉴에 채식 옵션이 있나요?)</span>

<mark>M</mark>: Yes, we do. We have a vegetable pasta dish and a tofu stir-fry.
<span class="translation">(네, 있습니다. 채소 파스타와 두부 볶음이 있습니다.)</span>

<mark>W</mark>: That sounds good. Does the pasta contain <mark>dairy products</mark>?
<span class="translation">(좋네요. 파스타에 유제품이 들어가나요?)</span>

<mark>M</mark>: Yes, it has cheese, but we can remove it upon request.
<span class="translation">(네, 치즈가 들어가지만 요청하시면 빼드릴 수 있습니다.)</span>

<mark>W</mark>: Great. I'll have the <mark>tofu stir-fry</mark> instead.
<span class="translation">(좋습니다. 대신 두부 볶음으로 하겠습니다.)</span>

<mark>M</mark>: Sure. Would you like brown rice or white rice with that?
<span class="translation">(알겠습니다. 현미밥과 백미 중 어떤 것으로 하시겠습니까?)</span>

<mark>W</mark>: Brown rice, please.
<span class="translation">(현미밥으로 부탁드립니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What does <mark>the woman</mark> ask about?",
        options: {
          A: "Whether the restaurant has <mark>vegetarian</mark> options",
          B: "The availability of a <mark>children's</mark> <mark>menu</mark>",
          C: "A <mark>special discount</mark> on lunch sets",
          D: "The <mark>daily</mark> <mark>soup</mark> selection",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Whether the restaurant has vegetarian options

대본 키워드: "Do you have vegetarian options on the menu?"
보기 키워드: "Whether the restaurant has vegetarian options"

❌ 오답 트랩:
(B) The availability of a children's menu 
→ 어린이 메뉴 문의 없음

(C) A special discount on lunch sets 
→ 런치 세트 할인 문의 없음

(D) The daily soup selection 
→ 오늘의 수프 문의 없음`,
      },
      {
        id: 2,
        question:
          "What concern does <mark>the woman</mark> have about the pasta dish?",
        options: {
          A: "It contains <mark>dairy</mark>",
          B: "It is too <mark>spicy</mark>",
          C: "It is <mark>not</mark> fully <mark>cooked</mark>",
          D: "It is too <mark>expensive</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) It contains dairy

대본 키워드: "Does the pasta contain dairy products?"
보기 키워드: "It contains dairy"

❌ 오답 트랩:
(B) It is too spicy 
→ 매운 맛 관련 언급 없음

(C) It is not fully cooked 
→ 조리 상태 관련 언급 없음

(D) It is too expensive 
→ 가격 관련 언급 없음`,
      },
      {
        id: 3,
        question: "What does <mark>the woman</mark> decide to order?",
        options: {
          A: "A grilled <mark>salmon</mark> platter",
          B: "A <mark>tofu</mark> stir-fry",
          C: "A chicken <mark>sandwich</mark>",
          D: "A seafood <mark>pasta</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A tofu stir-fry

대본 키워드: "I'll have the tofu stir-fry instead."
보기 키워드: "A tofu stir-fry"

❌ 오답 트랩:
(A) A grilled salmon platter 
→ 연어 플래터 주문 없음

(C) A chicken sandwich 
→ 치킨 샌드위치 주문 없음

(D) A seafood pasta 
→ 해산물 파스타 주문 없음`,
      },
    ],
  },
  conversation13: {
    id: 13,
    title: "Special Request - Food Allergies",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure13.mp3",
        script: `<mark>M</mark>: Hi, I have a <mark>peanut allergy</mark>. Can you tell me which dishes on the menu are safe for me to eat?
<span class="translation">(안녕하세요, 저는 땅콩 알레르기가 있는데요. 메뉴 중에서 제가 먹어도 안전한 음식이 어떤 것인지 알려주실 수 있나요?)</span>

<mark>W</mark>: Sure. Most of our dishes are peanut-free, but our <mark>Asian-style salads</mark> and satay skewers contain peanuts.
<span class="translation">(네. 대부분의 요리는 땅콩이 들어가지 않지만, 아시안 스타일 샐러드와 사테 꼬치에는 땅콩이 들어갑니다.)</span>

<mark>M</mark>: That's good to know. Can the salad be made without peanuts?
<span class="translation">(알려주셔서 감사합니다. 샐러드는 땅콩을 빼고 만들 수 있나요?)</span>

<mark>W</mark>: Yes, we can <mark>remove the peanuts</mark> upon request.
<span class="translation">(네, 요청하시면 땅콩을 빼드릴 수 있습니다.)</span>

<mark>M</mark>: Perfect. I'll have the grilled chicken salad without peanuts.
<span class="translation">(좋습니다. 땅콩을 뺀 그릴드 치킨 샐러드로 하겠습니다.)</span>

<mark>W</mark>: Got it. Would you like a dressing on the side?
<span class="translation">(알겠습니다. 드레싱은 따로 드릴까요?)</span>

<mark>M</mark>: Yes, please.
<span class="translation">(네, 그렇게 해주세요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What dietary concern does <mark>the man</mark> have?",
        options: {
          A: "He follows a <mark>vegetarian</mark> diet",
          B: "He has a peanut <mark>allergy</mark>",
          C: "He is <mark>lactose</mark> intolerant",
          D: "He prefers <mark>gluten-free</mark> meals",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) He has a peanut allergy

대본 키워드: "Hi, I have a peanut allergy."
보기 키워드: "He has a peanut allergy"

❌ 오답 트랩:
(A) He follows a vegetarian diet 
→ 채식주의자라는 언급 없음

(C) He is lactose intolerant 
→ 유당불내증이라는 언급 없음

(D) He prefers gluten-free meals 
→ 글루텐 프리 선호 언급 없음`,
      },
      {
        id: 2,
        question: "Which menu item contains peanuts?",
        options: {
          A: "The grilled chicken <mark>sandwich</mark>",
          B: "The seafood <mark>pasta</mark>",
          C: "The Asian-style <mark>salad</mark>",
          D: "The vegetable <mark>soup</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) The Asian-style salad

대본 키워드: "Our Asian-style salads and satay skewers contain peanuts."
보기 키워드: "The Asian-style salad"

❌ 오답 트랩:
(A) The grilled chicken sandwich 
→ 치킨 샌드위치 언급 없음

(B) The seafood pasta 
→ 해산물 파스타 언급 없음

(D) The vegetable soup 
→ 채소 수프 언급 없음`,
      },
      {
        id: 3,
        question:
          "How does the restaurant accommodate <mark>the man's</mark> request?",
        options: {
          A: "They offer to <mark>remove</mark> the <mark>peanuts</mark> from his meal",
          B: "They provide a <mark>separate</mark> <mark>allergy-free</mark> <mark>section</mark> in the <mark>kitchen</mark>",
          C: "They suggest an <mark>alternative</mark> dish",
          D: "They recommend dining at a <mark>different</mark> <mark>restaurant</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) They offer to remove the peanuts from his meal

🔍 정답 증명:

대본 키워드: "Yes, we can remove the peanuts upon request."
보기 키워드: "They offer to remove the peanuts from his meal"

❌ 오답 트랩 분석:
(B) They provide a separate allergy-free section in the kitchen 
→ 조리 공간을 따로 둔다는 언급 없음

(C) They suggest an alternative dish 
→ 새로운 요리를 추천하지 않고, 원래 메뉴에서 조정 가능

(D) They recommend dining at a different restaurant 
→ 식당을 바꾸라는 내용 없음`,
      },
    ],
  },
  conversation14: {
    id: 14,
    title: "Group Booking Inquiry",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure14.mp3",
        script: `<mark>M</mark>: Hi, I'd like to make a reservation for a <mark>company dinner</mark> next Friday evening. Do you accommodate large groups?
<span class="translation">(안녕하세요, 다음 주 금요일 저녁에 회사 저녁 식사 예약을 하고 싶은데요. 큰 단체도 수용 가능한가요?)</span>

<mark>W</mark>: Yes, we do. How many guests will be attending?
<span class="translation">(네, 가능합니다. 몇 분이나 오실 예정인가요?)</span>

<mark>M</mark>: Around 15 people. Do you have a <mark>private dining area</mark>?
<span class="translation">(약 15명 정도입니다. 개인 식사 공간이 있나요?)</span>

<mark>W</mark>: Yes, we have a separate dining room for groups of 10 or more. Would you like to reserve that?
<span class="translation">(네, 10명 이상 단체를 위한 별도의 식사 공간이 있습니다. 예약하시겠습니까?)</span>

<mark>M</mark>: That sounds perfect. What menu options do you offer for groups?
<span class="translation">(완벽하네요. 단체를 위한 메뉴 옵션은 어떤 것이 있나요?)</span>

<mark>W</mark>: We have a set menu with three options, including vegetarian dishes. I can <mark>email</mark> you the details.
<span class="translation">(채식 메뉴를 포함한 세 가지 세트 메뉴가 있습니다. 자세한 내용을 이메일로 보내드릴 수 있습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the man</mark> requesting?",
        options: {
          A: "A <mark>private meeting</mark> space",
          B: "A <mark>group reservation</mark> at a restaurant",
          C: "A table for <mark>two</mark>",
          D: "A <mark>catering</mark> <mark>service</mark> for an event",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A group reservation at a restaurant

대본 키워드: "I'd like to make a reservation for a company dinner next Friday evening."
보기 키워드: "A group reservation at a restaurant"

❌ 오답 트랩:
(A) A private meeting space 
→ 회의 공간이 아닌 식사 공간 요청

(C) A table for two 
→ 2인이 아닌 15인 예약

(D) A catering service for an event 
→ 케이터링 서비스 요청 없음`,
      },
      {
        id: 2,
        question: "What does the restaurant offer for large groups?",
        options: {
          A: "A <mark>private</mark> dining <mark>room</mark>",
          B: "A <mark>discount</mark> on meals",
          C: "Complimentary <mark>appetizers</mark>",
          D: "<mark>Free event planning</mark> services",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A private dining room

대본 키워드: "We have a separate dining room for groups of 10 or more."
보기 키워드: "A private dining room"

❌ 오답 트랩:
(B) A discount on meals 
→ 식사 할인 제공 언급 없음

(C) Complimentary appetizers 
→ 무료 에피타이저 제공 언급 없음

(D) Free event planning services 
→ 무료 이벤트 기획 서비스 언급 없음`,
      },
      {
        id: 3,
        question: "How will <mark>the woman</mark> provide menu details?",
        options: {
          A: "By mailing a printed <mark>brochure</mark>",
          B: "By sending an <mark>email</mark>",
          C: "By explaining over the <mark>phone</mark>",
          D: "By showing the man in <mark>person</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) By sending an email

대본 키워드: "I can email you the details."
보기 키워드: "By sending an email"

❌ 오답 트랩:
(A) By mailing a printed brochure 
→ 인쇄된 브로셔 발송 언급 없음

(C) By explaining over the phone 
→ 전화 설명 언급 없음

(D) By showing the man in person 
→ 직접 보여주기 언급 없음`,
      },
    ],
  },
  conversation15: {
    id: 15,
    title: "Event Space Rental",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure15.mp3",
        script: `<mark>W</mark>: Hi, I'm looking for a venue to host a <mark>corporate seminar</mark> next month. Do you have any available event spaces?
<span class="translation">(안녕하세요, 다음 달에 기업 세미나를 개최할 장소를 찾고 있는데요. 이용 가능한 행사 공간이 있나요?)</span>

<mark>M</mark>: Yes, we have a conference hall that can accommodate up to 100 guests.
<span class="translation">(네, 최대 100명까지 수용 가능한 컨퍼런스홀이 있습니다.)</span>

<mark>W</mark>: That sounds good. Does it include audiovisual equipment?
<span class="translation">(좋네요. 시청각 장비도 포함되어 있나요?)</span>

<mark>M</mark>: Yes, the space comes with a <mark>projector, a sound system</mark>, and wireless microphones.
<span class="translation">(네, 프로젝터, 음향 시스템, 무선 마이크가 제공됩니다.)</span>

<mark>W</mark>: Great. What is the rental fee?
<span class="translation">(좋습니다. 대여료는 얼마인가요?)</span>

<mark>M</mark>: It's <mark>$500 for a half-day rental</mark> and $900 for a full day. Would you like to proceed with the booking?
<span class="translation">(반나절 대여는 500달러, 종일 대여는 900달러입니다. 예약을 진행하시겠습니까?)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What kind of event is <mark>the woman</mark> planning?",
        options: {
          A: "A <mark>business</mark> <mark>seminar</mark>",
          B: "A <mark>wedding</mark> reception",
          C: "A product <mark>launch</mark>",
          D: "A <mark>charity</mark> fundraiser",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A business seminar

대본 키워드: "I'm looking for a venue to host a corporate seminar next month."
보기 키워드: "A business seminar"

❌ 오답 트랩:
(B) A wedding reception 
→ 결혼식 피로연 언급 없음

(C) A product launch 
→ 제품 출시 행사 언급 없음

(D) A charity fundraiser 
→ 자선 기금 모금 행사 언급 없음`,
      },
      {
        id: 2,
        question: "What equipment is included in the rental?",
        options: {
          A: "A <mark>stage</mark> and <mark>podium</mark>",
          B: "A <mark>projector</mark> and <mark>sound</mark> system",
          C: "<mark>Catering</mark> service",
          D: "High-speed <mark>internet</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A projector and sound system

대본 키워드: "The space comes with a projector, a sound system, and wireless microphones."
보기 키워드: "A projector and sound system"

❌ 오답 트랩:
(A) A stage and podium 
→ 무대와 연단 제공 언급 없음

(C) Catering service 
→ 케이터링 서비스 언급 없음

(D) High-speed internet 
→ 고속 인터넷 제공 언급 없음`,
      },
      {
        id: 3,
        question: "What does <mark>the man</mark> say about the pricing?",
        options: {
          A: "The fee is based on the <mark>number</mark> of <mark>guests</mark>",
          B: "It costs <mark>$500</mark> for a <mark>half-day</mark> rental",
          C: "The price includes <mark>catering</mark> services",
          D: "There is a <mark>10%</mark> discount for early bookings",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) It costs $500 for a half-day rental

대본 키워드: "It's $500 for a half-day rental and $900 for a full day."
보기 키워드: "It costs $500 for a half-day rental"

❌ 오답 트랩:
(A) The fee is based on the number of guests 
→ 손님 수에 따른 요금 책정 언급 없음

(C) The price includes catering services 
→ 케이터링 서비스 포함 언급 없음

(D) There is a 10% discount for early bookings 
→ 조기 예약 할인 언급 없음`,
      },
    ],
  },
  conversation16: {
    id: 16,
    title: "Car Rental",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/leisure/leisure16.mp3",
        script: `<mark>M</mark>: Hi, I'd like to <mark>rent a car</mark> for a business trip next week. What are my options?
<span class="translation">(안녕하세요, 다음 주 출장을 위해 차를 렌트하고 싶은데요. 어떤 옵션이 있나요?)</span>

<mark>W</mark>: We have several vehicles available. Are you looking for a compact car, an SUV, or a luxury sedan?
<span class="translation">(여러 차량이 있습니다. 소형차, SUV, 고급 세단 중 어떤 것을 찾으시나요?)</span>

<mark>M</mark>: A <mark>compact car</mark> would be fine. I'll need it from Monday to Thursday.
<span class="translation">(소형차면 좋겠습니다. 월요일부터 목요일까지 필요해요.)</span>

<mark>W</mark>: That works. Would you like to pick it up at the airport or our downtown location?
<span class="translation">(알겠습니다. 공항이나 시내 지점 중 어디서 수령하시겠어요?)</span>

<mark>M</mark>: I'll pick it up downtown and return it at the airport. Is there a drop-off fee for that?
<span class="translation">(시내에서 수령하고 공항에서 반납하겠습니다. 그럴 경우 반납 수수료가 있나요?)</span>

<mark>W</mark>: Yes, there's a <mark>small charge for returning the vehicle to a different location</mark>.
<span class="translation">(네, 다른 지점에 반납하실 경우 약간의 수수료가 있습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the man</mark> trying to do?",
        options: {
          A: "Compare rental <mark>prices</mark>",
          B: "<mark>Rent</mark> a <mark>vehicle</mark> for a few days",
          C: "Request car <mark>repair</mark> services",
          D: "Book a <mark>chauffeur</mark> service",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Rent a vehicle for a few days

대본 키워드: "I'd like to rent a car for a business trip next week."
보기 키워드: "Rent a vehicle for a few days"

❌ 오답 트랩:
(A) Compare rental prices 
→ 가격 비교가 아닌 예약 문의

(C) Request car repair services 
→ 차량 수리 서비스 언급 없음

(D) Book a chauffeur service 
→ 운전기사 서비스 언급 없음`,
      },
      {
        id: 2,
        question: "What type of car does <mark>the man</mark> choose?",
        options: {
          A: "A <mark>convertible</mark>",
          B: "A <mark>compact</mark> <mark>car</mark>",
          C: "A luxury <mark>sedan</mark>",
          D: "An <mark>electric</mark> vehicle",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A compact car

대본 키워드: "A compact car would be fine."
보기 키워드: "A compact car"

❌ 오답 트랩:
(A) A convertible 
→ 컨버터블 차량 언급 없음

(C) A luxury sedan 
→ 고급 세단 선택하지 않음

(D) An electric vehicle 
→ 전기차 언급 없음`,
      },
      {
        id: 3,
        question: "What additional fee does <mark>the woman</mark> mention?",
        options: {
          A: "A <mark>drop-off</mark> <mark>fee</mark> for returning the car at a <mark>different</mark> <mark>location</mark>",
          B: "A <mark>charge</mark> for exceeding the <mark>mileage</mark> <mark>limit</mark>",
          C: "A <mark>cleaning</mark> <mark>fee</mark> for returning the car <mark>late</mark>",
          D: "A <mark>security deposit</mark> for premium vehicles",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A drop-off fee for returning the car at a different location

대본 키워드: "There's a small charge for returning the vehicle to a different location."
보기 키워드: "A drop-off fee for returning the car at a different location"

❌ 오답 트랩:
(B) A charge for exceeding the mileage limit 
→ 주행거리 초과 요금 언급 없음

(C) A cleaning fee for returning the car late 
→ 청소비나 연체료 언급 없음

(D) A security deposit for premium vehicles 
→ 프리미엄 차량 보증금 언급 없음`,
      },
    ],
  },
};
